import { render, staticRenderFns } from "./OrderConfirmList.vue?vue&type=template&id=7831f738&scoped=true"
import script from "./OrderConfirmList.vue?vue&type=script&lang=js"
export * from "./OrderConfirmList.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmList.vue?vue&type=style&index=0&id=7831f738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831f738",
  null
  
)

export default component.exports